import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import CorneredCard from "components/CorneredCard";
import NotificationsActions from "../myNotifications/actions";
import { INotification } from "models/.";
import Button from "components/Button";
import AnimatedArrow from "components/AnimatedArrow";
import { URLS } from "constants/urlConstants";
import Pagination from "components/Table/partials/Pagination";
import IMeta from "models/IMeta";
import { CUSTOM_SETTINGS } from "constants/.";

import "./style.scss";

interface IProps {
  local: string;
  getNotifications: (meta?: IMeta, isCurrent?: boolean) => void;
  notifications: INotification[];
  count: number;
}

interface IState {
  currentPage: number;
  pageSize: number;
}

class AllNotifications extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 0,
      pageSize: 10,
    };
  }

  public componentDidMount() {
    const savedSettings = JSON.parse(
      localStorage.getItem("customSettings") || "{}"
    );
    const pageSize = _.get(
      savedSettings,
      `${CUSTOM_SETTINGS.allNotifications}.pageSize`,
      10
    );

    this.setState({ pageSize });
    this.props.getNotifications({ pageSize }, true); // Request gets sent in form here
  }

  private handlePageChange = (meta) => {
    const newMeta = { ...this.state, ...meta };
    this.setState(newMeta);
    this.props.getNotifications(newMeta, true);
  };

  public render() {
    const { notifications, local, count } = this.props;

    return (
      <div id="notifications-page">
        <FormattedMessage id="NOTIFICATIONS" tagName="h1" />
        {_.orderBy(notifications, "DateFrom", "desc").map((item) => (
          <CorneredCard
            color="alice"
            size="big"
            className="notification-card"
            key={item._id}
          >
            <div className="text-wrapper">
              {item.Important && (
                <span className="notification-important">!</span>
              )}
              <p className="notification-date">
                {moment(item.DateFrom).locale("nl").format("LL")}
              </p>
              <h2 className="notification-title">{item[`Title_${local}`]}</h2>
              <p className="notification-text">{item[`Text_${local}`]}</p>
            </div>

            {item.Files && (
              <Link
                to={`${URLS.OPEN_DOCUMENT}/${_.get(item, "Files._id")}`}
                target="_blank"
              >
                <Button
                  className="notification-btn reversed"
                  icon={<AnimatedArrow />}
                >
                  VIEW_PDF
                </Button>
              </Link>
            )}
          </CorneredCard>
        ))}
        {!notifications?.length && (
          <h2 className="message">
            <FormattedMessage id="NO_DATA" />
          </h2>
        )}
        {!!notifications?.length && (
          <Pagination
            meta={{ count, ...this.state }}
            onPageChange={this.handlePageChange}
            pageName={CUSTOM_SETTINGS.allNotifications}
          />
        )}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    notifications: state.notifications.items,
    local: state.app.user.profile.Language,
    count: state.notifications.meta.count || 0,
  }),
  {
    getNotifications: NotificationsActions.getNotifications,
  }
)(AllNotifications);
